/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiTicketsAdminOrdersGetPageParameter,
  ApiTicketsAdminOrdersGetPageSizeParameter,
  ApiUserTasksGetLastSelectedIdParameter,
  Query,
  Result,
  ResultOfIReadOnlyListOfPublicTicketEvent,
  ResultOfIReadOnlyListOfTicketAdmission,
  ResultOfIReadOnlyListOfTicketEventDetail,
  ResultOfIReadOnlyListOfTicketPromoCodeDetail,
  ResultOfPublicTicketEvent,
  ResultOfResponse,
  ResultOfTicketEventDetail,
  ResultOfTicketPromoCodeDetail,
  TicketCheckoutRequest,
  TicketRefundRequest,
  TicketResendRequest,
  TicketScanRequest,
  TicketScanUndoRequest,
  UpsertStudioPromoCodeRequest,
  UpsertTicketEventRequest,
} from '../models/index';
import {
    ApiTicketsAdminOrdersGetPageParameterFromJSON,
    ApiTicketsAdminOrdersGetPageParameterToJSON,
    ApiTicketsAdminOrdersGetPageSizeParameterFromJSON,
    ApiTicketsAdminOrdersGetPageSizeParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    QueryFromJSON,
    QueryToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfIReadOnlyListOfPublicTicketEventFromJSON,
    ResultOfIReadOnlyListOfPublicTicketEventToJSON,
    ResultOfIReadOnlyListOfTicketAdmissionFromJSON,
    ResultOfIReadOnlyListOfTicketAdmissionToJSON,
    ResultOfIReadOnlyListOfTicketEventDetailFromJSON,
    ResultOfIReadOnlyListOfTicketEventDetailToJSON,
    ResultOfIReadOnlyListOfTicketPromoCodeDetailFromJSON,
    ResultOfIReadOnlyListOfTicketPromoCodeDetailToJSON,
    ResultOfPublicTicketEventFromJSON,
    ResultOfPublicTicketEventToJSON,
    ResultOfResponseFromJSON,
    ResultOfResponseToJSON,
    ResultOfTicketEventDetailFromJSON,
    ResultOfTicketEventDetailToJSON,
    ResultOfTicketPromoCodeDetailFromJSON,
    ResultOfTicketPromoCodeDetailToJSON,
    TicketCheckoutRequestFromJSON,
    TicketCheckoutRequestToJSON,
    TicketRefundRequestFromJSON,
    TicketRefundRequestToJSON,
    TicketResendRequestFromJSON,
    TicketResendRequestToJSON,
    TicketScanRequestFromJSON,
    TicketScanRequestToJSON,
    TicketScanUndoRequestFromJSON,
    TicketScanUndoRequestToJSON,
    UpsertStudioPromoCodeRequestFromJSON,
    UpsertStudioPromoCodeRequestToJSON,
    UpsertTicketEventRequestFromJSON,
    UpsertTicketEventRequestToJSON,
} from '../models/index';

export interface ApiTicketsAdminEventsGetRequest {
    xTenantID?: number;
}

export interface ApiTicketsAdminEventsIdAdmissionsGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTicketsAdminEventsIdClosePostRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTicketsAdminEventsIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTicketsAdminEventsIdGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTicketsAdminEventsIdPutRequest {
    id: number;
    upsertTicketEventRequest: UpsertTicketEventRequest;
    xTenantID?: number;
}

export interface ApiTicketsAdminEventsPostRequest {
    upsertTicketEventRequest: UpsertTicketEventRequest;
    xTenantID?: number;
}

export interface ApiTicketsAdminOrdersGetRequest {
    eventId?: ApiUserTasksGetLastSelectedIdParameter;
    status?: string;
    search?: string;
    page?: ApiTicketsAdminOrdersGetPageParameter;
    pageSize?: ApiTicketsAdminOrdersGetPageSizeParameter;
    xTenantID?: number;
}

export interface ApiTicketsAdminOrdersOrderCodeRefundPostRequest {
    orderCode: string;
    xTenantID?: number;
    ticketRefundRequest?: TicketRefundRequest;
}

export interface ApiTicketsAdminOrdersOrderCodeReleasePostRequest {
    orderCode: string;
    xTenantID?: number;
}

export interface ApiTicketsAdminOrdersOrderCodeResendPostRequest {
    orderCode: string;
    xTenantID?: number;
    ticketResendRequest?: TicketResendRequest;
}

export interface ApiTicketsAdminPromoCodesGetRequest {
    xTenantID?: number;
}

export interface ApiTicketsAdminPromoCodesIdPutRequest {
    id: number;
    upsertStudioPromoCodeRequest: UpsertStudioPromoCodeRequest;
    xTenantID?: number;
}

export interface ApiTicketsAdminPromoCodesPostRequest {
    upsertStudioPromoCodeRequest: UpsertStudioPromoCodeRequest;
    xTenantID?: number;
}

export interface ApiTicketsAdminScanPostRequest {
    ticketScanRequest: TicketScanRequest;
    xTenantID?: number;
}

export interface ApiTicketsAdminScanUndoPostRequest {
    ticketScanUndoRequest: TicketScanUndoRequest;
    xTenantID?: number;
}

export interface ApiTicketsCheckoutPostRequest {
    ticketCheckoutRequest: TicketCheckoutRequest;
    xTenantID?: number;
}

export interface ApiTicketsCheckoutQuotePostRequest {
    query: Query;
    xTenantID?: number;
}

export interface ApiTicketsEventsGetRequest {
    xTenantID?: number;
}

export interface ApiTicketsEventsSlugGetRequest {
    slug: string;
    xTenantID?: number;
}

export interface ApiTicketsOrdersAccessTokenGetRequest {
    accessToken: string;
    xTenantID?: number;
}

/**
 * 
 */
export class TicketsApi extends runtime.BaseAPI {

    /**
     */
    async apiTicketsAdminEventsGetRaw(requestParameters: ApiTicketsAdminEventsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIReadOnlyListOfTicketEventDetail>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/events`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIReadOnlyListOfTicketEventDetailFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminEventsGet(requestParameters: ApiTicketsAdminEventsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIReadOnlyListOfTicketEventDetail> {
        const response = await this.apiTicketsAdminEventsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminEventsIdAdmissionsGetRaw(requestParameters: ApiTicketsAdminEventsIdAdmissionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIReadOnlyListOfTicketAdmission>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTicketsAdminEventsIdAdmissionsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/events/{id}/admissions`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIReadOnlyListOfTicketAdmissionFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminEventsIdAdmissionsGet(requestParameters: ApiTicketsAdminEventsIdAdmissionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIReadOnlyListOfTicketAdmission> {
        const response = await this.apiTicketsAdminEventsIdAdmissionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminEventsIdClosePostRaw(requestParameters: ApiTicketsAdminEventsIdClosePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfTicketEventDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTicketsAdminEventsIdClosePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/events/{id}/close`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfTicketEventDetailFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminEventsIdClosePost(requestParameters: ApiTicketsAdminEventsIdClosePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfTicketEventDetail> {
        const response = await this.apiTicketsAdminEventsIdClosePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminEventsIdDeleteRaw(requestParameters: ApiTicketsAdminEventsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTicketsAdminEventsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/events/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminEventsIdDelete(requestParameters: ApiTicketsAdminEventsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.apiTicketsAdminEventsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminEventsIdGetRaw(requestParameters: ApiTicketsAdminEventsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfTicketEventDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTicketsAdminEventsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/events/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfTicketEventDetailFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminEventsIdGet(requestParameters: ApiTicketsAdminEventsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfTicketEventDetail> {
        const response = await this.apiTicketsAdminEventsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminEventsIdPutRaw(requestParameters: ApiTicketsAdminEventsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfTicketEventDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTicketsAdminEventsIdPut().'
            );
        }

        if (requestParameters['upsertTicketEventRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertTicketEventRequest',
                'Required parameter "upsertTicketEventRequest" was null or undefined when calling apiTicketsAdminEventsIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/events/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertTicketEventRequestToJSON(requestParameters['upsertTicketEventRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfTicketEventDetailFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminEventsIdPut(requestParameters: ApiTicketsAdminEventsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfTicketEventDetail> {
        const response = await this.apiTicketsAdminEventsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminEventsPostRaw(requestParameters: ApiTicketsAdminEventsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfTicketEventDetail>> {
        if (requestParameters['upsertTicketEventRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertTicketEventRequest',
                'Required parameter "upsertTicketEventRequest" was null or undefined when calling apiTicketsAdminEventsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/events`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertTicketEventRequestToJSON(requestParameters['upsertTicketEventRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfTicketEventDetailFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminEventsPost(requestParameters: ApiTicketsAdminEventsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfTicketEventDetail> {
        const response = await this.apiTicketsAdminEventsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminOrdersGetRaw(requestParameters: ApiTicketsAdminOrdersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfResponse>> {
        const queryParameters: any = {};

        if (requestParameters['eventId'] != null) {
            queryParameters['eventId'] = requestParameters['eventId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/orders`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminOrdersGet(requestParameters: ApiTicketsAdminOrdersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfResponse> {
        const response = await this.apiTicketsAdminOrdersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminOrdersOrderCodeRefundPostRaw(requestParameters: ApiTicketsAdminOrdersOrderCodeRefundPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfResponse>> {
        if (requestParameters['orderCode'] == null) {
            throw new runtime.RequiredError(
                'orderCode',
                'Required parameter "orderCode" was null or undefined when calling apiTicketsAdminOrdersOrderCodeRefundPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/orders/{orderCode}/refund`;
        urlPath = urlPath.replace(`{${"orderCode"}}`, encodeURIComponent(String(requestParameters['orderCode'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TicketRefundRequestToJSON(requestParameters['ticketRefundRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminOrdersOrderCodeRefundPost(requestParameters: ApiTicketsAdminOrdersOrderCodeRefundPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfResponse> {
        const response = await this.apiTicketsAdminOrdersOrderCodeRefundPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminOrdersOrderCodeReleasePostRaw(requestParameters: ApiTicketsAdminOrdersOrderCodeReleasePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfResponse>> {
        if (requestParameters['orderCode'] == null) {
            throw new runtime.RequiredError(
                'orderCode',
                'Required parameter "orderCode" was null or undefined when calling apiTicketsAdminOrdersOrderCodeReleasePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/orders/{orderCode}/release`;
        urlPath = urlPath.replace(`{${"orderCode"}}`, encodeURIComponent(String(requestParameters['orderCode'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminOrdersOrderCodeReleasePost(requestParameters: ApiTicketsAdminOrdersOrderCodeReleasePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfResponse> {
        const response = await this.apiTicketsAdminOrdersOrderCodeReleasePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminOrdersOrderCodeResendPostRaw(requestParameters: ApiTicketsAdminOrdersOrderCodeResendPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfResponse>> {
        if (requestParameters['orderCode'] == null) {
            throw new runtime.RequiredError(
                'orderCode',
                'Required parameter "orderCode" was null or undefined when calling apiTicketsAdminOrdersOrderCodeResendPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/orders/{orderCode}/resend`;
        urlPath = urlPath.replace(`{${"orderCode"}}`, encodeURIComponent(String(requestParameters['orderCode'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TicketResendRequestToJSON(requestParameters['ticketResendRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminOrdersOrderCodeResendPost(requestParameters: ApiTicketsAdminOrdersOrderCodeResendPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfResponse> {
        const response = await this.apiTicketsAdminOrdersOrderCodeResendPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminPromoCodesGetRaw(requestParameters: ApiTicketsAdminPromoCodesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIReadOnlyListOfTicketPromoCodeDetail>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/promo-codes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIReadOnlyListOfTicketPromoCodeDetailFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminPromoCodesGet(requestParameters: ApiTicketsAdminPromoCodesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIReadOnlyListOfTicketPromoCodeDetail> {
        const response = await this.apiTicketsAdminPromoCodesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminPromoCodesIdPutRaw(requestParameters: ApiTicketsAdminPromoCodesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfTicketPromoCodeDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTicketsAdminPromoCodesIdPut().'
            );
        }

        if (requestParameters['upsertStudioPromoCodeRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertStudioPromoCodeRequest',
                'Required parameter "upsertStudioPromoCodeRequest" was null or undefined when calling apiTicketsAdminPromoCodesIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/promo-codes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertStudioPromoCodeRequestToJSON(requestParameters['upsertStudioPromoCodeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfTicketPromoCodeDetailFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminPromoCodesIdPut(requestParameters: ApiTicketsAdminPromoCodesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfTicketPromoCodeDetail> {
        const response = await this.apiTicketsAdminPromoCodesIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminPromoCodesPostRaw(requestParameters: ApiTicketsAdminPromoCodesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfTicketPromoCodeDetail>> {
        if (requestParameters['upsertStudioPromoCodeRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertStudioPromoCodeRequest',
                'Required parameter "upsertStudioPromoCodeRequest" was null or undefined when calling apiTicketsAdminPromoCodesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/promo-codes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertStudioPromoCodeRequestToJSON(requestParameters['upsertStudioPromoCodeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfTicketPromoCodeDetailFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminPromoCodesPost(requestParameters: ApiTicketsAdminPromoCodesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfTicketPromoCodeDetail> {
        const response = await this.apiTicketsAdminPromoCodesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminScanPostRaw(requestParameters: ApiTicketsAdminScanPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfResponse>> {
        if (requestParameters['ticketScanRequest'] == null) {
            throw new runtime.RequiredError(
                'ticketScanRequest',
                'Required parameter "ticketScanRequest" was null or undefined when calling apiTicketsAdminScanPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/scan`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TicketScanRequestToJSON(requestParameters['ticketScanRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminScanPost(requestParameters: ApiTicketsAdminScanPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfResponse> {
        const response = await this.apiTicketsAdminScanPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsAdminScanUndoPostRaw(requestParameters: ApiTicketsAdminScanUndoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfResponse>> {
        if (requestParameters['ticketScanUndoRequest'] == null) {
            throw new runtime.RequiredError(
                'ticketScanUndoRequest',
                'Required parameter "ticketScanUndoRequest" was null or undefined when calling apiTicketsAdminScanUndoPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/admin/scan/undo`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TicketScanUndoRequestToJSON(requestParameters['ticketScanUndoRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsAdminScanUndoPost(requestParameters: ApiTicketsAdminScanUndoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfResponse> {
        const response = await this.apiTicketsAdminScanUndoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsCheckoutPostRaw(requestParameters: ApiTicketsCheckoutPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfResponse>> {
        if (requestParameters['ticketCheckoutRequest'] == null) {
            throw new runtime.RequiredError(
                'ticketCheckoutRequest',
                'Required parameter "ticketCheckoutRequest" was null or undefined when calling apiTicketsCheckoutPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/checkout`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TicketCheckoutRequestToJSON(requestParameters['ticketCheckoutRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsCheckoutPost(requestParameters: ApiTicketsCheckoutPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfResponse> {
        const response = await this.apiTicketsCheckoutPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsCheckoutQuotePostRaw(requestParameters: ApiTicketsCheckoutQuotePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfResponse>> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling apiTicketsCheckoutQuotePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/checkout/quote`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QueryToJSON(requestParameters['query']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsCheckoutQuotePost(requestParameters: ApiTicketsCheckoutQuotePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfResponse> {
        const response = await this.apiTicketsCheckoutQuotePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsEventsGetRaw(requestParameters: ApiTicketsEventsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIReadOnlyListOfPublicTicketEvent>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/events`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIReadOnlyListOfPublicTicketEventFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsEventsGet(requestParameters: ApiTicketsEventsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIReadOnlyListOfPublicTicketEvent> {
        const response = await this.apiTicketsEventsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsEventsSlugGetRaw(requestParameters: ApiTicketsEventsSlugGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfPublicTicketEvent>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling apiTicketsEventsSlugGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/events/{slug}`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfPublicTicketEventFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsEventsSlugGet(requestParameters: ApiTicketsEventsSlugGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfPublicTicketEvent> {
        const response = await this.apiTicketsEventsSlugGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTicketsOrdersAccessTokenGetRaw(requestParameters: ApiTicketsOrdersAccessTokenGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfResponse>> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling apiTicketsOrdersAccessTokenGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tickets/orders/{accessToken}`;
        urlPath = urlPath.replace(`{${"accessToken"}}`, encodeURIComponent(String(requestParameters['accessToken'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketsOrdersAccessTokenGet(requestParameters: ApiTicketsOrdersAccessTokenGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfResponse> {
        const response = await this.apiTicketsOrdersAccessTokenGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
